import { BRAND } from "@/lib/siteData";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "This placeholder Privacy Policy explains how Vivek Parekh Production handles information submitted through this website. Replace with your finalized legal copy.",
    sections: [
      { h: "Information We Collect", p: "We collect the details you voluntarily provide through the enquiry form, such as your name, company, email, phone number, and project details." },
      { h: "How We Use It", p: "Submitted information is used solely to respond to your enquiry and discuss potential collaborations. We do not sell your data." },
      { h: "Data Retention", p: "Enquiry details are retained only as long as necessary to serve your request. Contact us to request removal." },
      { h: "Contact", p: `For any privacy questions, email ${BRAND.email}.` },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "These placeholder Terms & Conditions govern the use of the Vivek Parekh Production website. Replace with your finalized legal copy.",
    sections: [
      { h: "Use of Content", p: "All content, imagery, and branding on this site are for informational purposes. Portfolio items shown may be placeholders pending verified additions." },
      { h: "Celebrity Associations", p: "No celebrity association is implied unless officially confirmed and authorized. Availability, terms, usage rights, and approvals are subject to individual agreements." },
      { h: "Enquiries", p: "Submitting an enquiry does not constitute a binding agreement. Project terms are defined in separate written contracts." },
      { h: "Contact", p: `For questions regarding these terms, email ${BRAND.email}.` },
    ],
  },
};

export default function Legal({ type }) {
  const data = CONTENT[type] || CONTENT.privacy;
  return (
    <div className="pt-36 md:pt-44 pb-24 container-x max-w-4xl" data-testid={`legal-${type}`}>
      <p className="text-xs md:text-sm tracking-[0.35em] uppercase font-bold text-gold mb-5">Legal</p>
      <h1 className="font-display text-6xl md:text-8xl uppercase tracking-tight text-offwhite">{data.title}</h1>
      <p className="mt-8 text-white/60 font-light leading-relaxed text-lg">{data.intro}</p>
      <div className="mt-12 space-y-10">
        {data.sections.map((s) => (
          <div key={s.h} className="border-t border-white/15 pt-6">
            <h2 className="font-serif italic text-2xl md:text-3xl text-offwhite">{s.h}</h2>
            <p className="mt-3 text-white/60 font-light leading-relaxed">{s.p}</p>
          </div>
        ))}
      </div>
      <p className="mt-16 text-white/30 text-xs italic">This is placeholder legal text and does not constitute legal advice.</p>
    </div>
  );
}
